import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from '../../../auth/core/Auth'
import { useCouponTransactionsDash } from './CouponTransactionsDashboard'
import { get_coupon_transaction_filters, get_coupon_transaction_filters_types, get_coupon_transaction_query } from '../../core/_request'
import { Card, Dropdown } from 'react-bootstrap'
import CouponTransactionsFilterComp from './CouponTransactionsFilterComp'
import { KTCard, KTCardBody, KTIcon, QueryStateI } from '../../../../../general/helpers'
import { CouponTransactionsTable } from './table/coupon-transactions-table/CouponTransactionsTable'
import clsx from 'clsx'
import ListLoading from '../../dashboad/components/loading/ListLoading'
import { PageTitle } from '../../../../../general/layout/core'
import Pagination from '../../components/Pagination'
import { PaginationI } from '../../core/_models'
import { useIntl } from 'react-intl'
import momentTimezone from 'moment-timezone'
import { parseJwt } from '../../core/helper'
import { useClearSessionOnModuleEntry } from '../../hooks/useClearSessionOnModuleEntry'

function CouponTransactionsDashboardLayout() {
  const [filter, setFilter] = useState<any>(undefined)
  const [filterQueryStr, setFilterQueryStr] = useState<string>('')
  const [filtersFromSession, setFiltersFromSession] = useState<{
    [name: string]: any
  }>({})
  const [filterLoad, setFilterLoad] = useState<boolean>(false)
  const [totalItems, setTotalItems] = useState(100)
  const [pagination, setPagination] = useState<PaginationI>({
    size: 10,
    page: 1,
  })
  const [tableLoad, setTableLoad] = useState(false)
  const refTransactionsList = useRef(null)
  const { auth, logout } = useAuth()
  const { activeRetailer } = parseJwt(auth?.accessToken ?? '')
  const {
    filtersType,
    saveFiltersType,
    saveSelectedFilterType,
    selectedFilterType,
    saveQueryListings,
    querylistings,
  } = useCouponTransactionsDash()
  const intl = useIntl()

  useClearSessionOnModuleEntry(['/promotions/transactions']);


  const GetFiltersType = async () => {
    setFilterLoad(true)
    try {
      const { data } = await get_coupon_transaction_filters_types(auth?.accessToken)
      saveFiltersType(data)
      const advancedType = data.find((_type) => _type.slug === 'promotion-transactions')
      if (advancedType) {
        saveSelectedFilterType(advancedType)
      } else {
        setFilterLoad(false)
      }
    } catch (error) {
      console.log(error)
      setFilterLoad(false)
    }
  }

  const GetFiltersbyId = async () => {
    try {
      const { data } = await get_coupon_transaction_filters(auth?.accessToken, { type: selectedFilterType?._id })
      data.sort((a, b) => a?.order - b?.order)
      setFilter(data)
      setFilterLoad(false)
    } catch (error) {
      console.log(error)
      setFilterLoad(false)
    }
  }
  const getSelectedFilter = () => {
    if (filter) {
      return filter.filter((e) => e.type._id === selectedFilterType?._id)
    }
    return undefined
  }

  useEffect(() => {
    if (!auth?.accessToken) {
      logout()
      return
    }
    filtersType ?? GetFiltersType()

    let tempQuery = sessionStorage.getItem('filterQueryStr')
    if (tempQuery && tempQuery !== '') {
      setFilterLoad(true)
      setFilterQueryStr(tempQuery)
      const tempFilters: { [name: string]: any } = {}
      tempQuery = tempQuery.slice(1)
      if (tempQuery.includes('&')) {
        const queries = tempQuery.split('&')
        queries.forEach((query: string) => {
          const attributeQuery = query.split('=')?.[0]
          const attribute =
            attributeQuery.includes('.') && !attributeQuery.includes('createdDateTime')
              ? attributeQuery?.split('.')?.[0]
              : attributeQuery
          if (!tempFilters?.[attribute]) {
            const val = query.split('=')?.[1]
            const decodedString = decodeURIComponent(val)
            tempFilters[attribute] = decodedString ?? ''
          }
        })
      } else {
        const val = tempQuery.split('=')?.[1]
        const attribute = tempQuery.split('=')?.[0]?.split('.')?.[0] ?? ''
        tempFilters[attribute] = decodeURIComponent(val) ?? ''
      }
      setFiltersFromSession({ ...tempFilters })
    } else {
      // FO: by default we define "FROM" to TODAY
      const today = momentTimezone().tz(activeRetailer?.timeZone).startOf('day').toISOString()
      const defaultFilter = {
        "createdDateTime.greaterThanOrEqual": today,
        page: 0,
        size: 20,
      };
      setFiltersFromSession(defaultFilter);
      setFilterQueryStr(
        `createdDateTime.greaterThanOrEqual=${encodeURIComponent(defaultFilter["createdDateTime.greaterThanOrEqual"])}&page=${defaultFilter.page}&size=${defaultFilter.size}`
      );

      sessionStorage.setItem(
        'filterQueryStr',
        `createdDateTime.greaterThanOrEqual=${encodeURIComponent(defaultFilter["createdDateTime.greaterThanOrEqual"])}&page=${defaultFilter.page}&size=${defaultFilter.size}`
      );

      setPagination({ page: 1, size: 20 });
    }
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    selectedFilterType?._id && GetFiltersbyId()
    //eslint-disable-next-line
  }, [selectedFilterType])

  return (
    <>
      <PageTitle>{intl.formatMessage({ id: 'FILTERS' })}</PageTitle>
      <KTCard>
        {/*<div className='card-header pt-6 border-0 justify-content-end'>
          {filtersType && (
            <Dropdown
              onSelect={(e) => {
                if (selectedFilterType._id === e) return
                setFilterLoad(true)
                saveSelectedFilterType(filtersType.find((_type) => _type._id === e))
                saveQueryListings([])
              }}
              className='w-200px'
            >
              <Dropdown.Toggle
                className='btn btn-light-primary w-100 d-flex align-items-center justify-content-between'
                id='dropdown-basic'
              >
                <span className='d-flex align-items-center'>
                  <KTIcon iconName='filter' className='me-1 fs-2' />
                  {selectedFilterType?.name ?? 'Select'}
                </span>
              </Dropdown.Toggle>-->
              <Dropdown.Menu className='min-w-100'>
                {filtersType.map((single_filter: {slug: string; name: string; _id: string}) => {
                  const {slug, name, _id} = single_filter
                  return (
                    <Dropdown.Item
                      eventKey={_id}
                      key={slug}
                      className={clsx({active: selectedFilterType._id === _id})}
                    >
                      {name}
                    </Dropdown.Item>
                  )
                })}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>*/}

        {filterLoad ? (
          <Card>
            <Card.Body>
              <div className='d-flex justify-content-center align-items-center'>
                <span className='me-2'>Please wait...</span>
                <span className='spinner-border spinner-border-md align-middle text-primary' />
              </div>
            </Card.Body>
          </Card>
        ) : (
          <KTCardBody className='pt-2'>
            <CouponTransactionsFilterComp
              filters={getSelectedFilter() || []}
              setFilterQueryStr={setFilterQueryStr}
              filtersFromSession={filtersFromSession}
              setFiltersFromSession={setFiltersFromSession}
              filterLoad={filterLoad}
              setFilterLoad={setFilterLoad}
              pagination={pagination}
              setPagination={setPagination}
              setTotalItems={setTotalItems}
              setTableLoad={setTableLoad}
              tableLoad={tableLoad}
              listRef={refTransactionsList}
            />
          </KTCardBody>
        )}

        <div ref={refTransactionsList} />
      </KTCard>
      {querylistings?.length > 0 || tableLoad ? (
        <KTCard className='mt-5'>
          <KTCardBody>
            <CouponTransactionsTable filterQueryStr={filterQueryStr} />
            <Pagination
              totalItems={totalItems}
              state={pagination}
              updateState={(obj: Partial<QueryStateI>) => {
                setPagination({ page: obj?.page ?? 1, size: obj?.size ?? 10 })
              }}
            />
            {tableLoad ? <ListLoading /> : <></>}
          </KTCardBody>
        </KTCard>
      ) : (
        <></>
      )}
    </>
  )
}

export default CouponTransactionsDashboardLayout
